import { LayoutInvoice } from './Layout/LayoutInvoice'
export const InvoiceScreen = () => {
  return (
    <LayoutInvoice />
  )
}
